export default [
  {
    path: 'ips',
    name: 'ips',
    component: () => import('./views/IPSView.vue'),
    meta: {
      title: 'IPS'
    }
  }
]
